import { BREAKPOINTS } from '@consts';
import { useEffect, useState } from 'react';

export function useIsMobile(returnImmediate = true) {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const checkIsMobile = () => {
      // 1. Modern approach: User-Agent Client Hints API (Chrome 90+, Edge 90+)
      if ('userAgentData' in navigator) {
        return (navigator as any).userAgentData.mobile;
      }

      // 2. Fallback: Comprehensive UA string detection
      const userAgent = navigator.userAgent || '';
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB10|IEMobile|Opera Mini|Mobile|mobile|CriOS|Windows Phone|WPDesktop|Lumia|Silk|Kindle|PlayBook|Symbian|Nokia|SamsungBrowser|UCBrowser|MQQBrowser|Huawei|HMSCore|ONEPLUS|Xiaomi|Redmi|POCOPHONE|Mi |HarmonyOS|Sailfish/i;

      if (mobileRegex.test(userAgent)) {
        return true;
      }

      // 3. Last resort: Viewport width check
      return window.matchMedia(`(max-width: ${BREAKPOINTS.MOBILE - 1}px)`).matches;
    };

    const mql = window.matchMedia(`(max-width: ${BREAKPOINTS.MOBILE - 1}px)`);
    const onChange = () => {
      setIsMobile(checkIsMobile());
    };
    mql.addEventListener('change', onChange);
    setIsMobile(checkIsMobile());
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
